import React, { useState } from "react";
import coupleImg from "../../Assets/SignUp/coupleImg.jpeg";
import heading from "../../Assets/SignUp/heading.png";
import bg from "../../Assets/SignUp/bg.png";
import absolute from "../../Assets/SignUp/absolute.png";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaRegEyeSlash } from "react-icons/fa";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { resetPassword } from "../../Redux/Actions/AuthAction";
import { CircularProgress } from "@mui/material";
import useTitle from "../../Hooks/useTitle";

const Setnewpass = () => {
    useTitle('Reset Password')
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const email = queryParams.get("email");

    const { loading } = useSelector((state) => state.Auth);
    const dispatch = useDispatch();

    // Initialize state as objects with both value and show properties
    const [password, setPassword] = useState({ show: false, value: "" });
    const [confirmPassword, setConfirmPassword] = useState({ show: false, value: "" });

    const handleResetPassword = async () => {
        if (!password.value || !confirmPassword.value) {
            return toast.error("Both fields are required !!");
        }

        try {
            const res = await dispatch(
                resetPassword(token, email, password.value, confirmPassword.value)
            );
            if (!res) {
                return toast.error("Something went wrong !! Please try again..");
            }
            toast.success("Password Reset Successfully");
            navigate("/reset-password-success");
        } catch (error) {

            if (error?.response?.data?.errors) {
                const key = error?.response?.data?.errors;
                const firstField = Object.keys(key)[0];
                if (firstField && key[firstField].length > 0) {
                    toast.error(key[firstField][0]);
                }
            } else {
                toast.error(error.response.data.message);
            }
        }
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen md:h-screen overflow-hidden">
            {/* Left Side Image */}
            <div className="hidden md:flex relative justify-center items-center p-4 md:h-screen">
                <div className="w-full h-full relative">
                    <img
                        src={coupleImg}
                        alt="Couple"
                        className="w-full h-full object-cover rounded-xl"
                    />
                    {/* Overlay Content */}
                    <div className="absolute top-4 left-1/2 transform -translate-x-1/2 text-center text-white">
                        <img src={absolute} alt="Decorative Icon" className="mx-auto mb-2" />
                        <h1 className="text-lg md:text-xl lg:text-2xl font-bold">Add USA</h1>
                        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold">Gujarati Community</h2>
                    </div>
                </div>
            </div>

            {/* Right Side Form */}
            <div
                className="flex items-center justify-center min-h-screen md:h-full p-4 md:p-8"
                style={{
                    backgroundImage: `url(${bg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="w-full lg:w-[80%] bg-white p-6 md:p-8 rounded-lg">
                    <div className="flex justify-center">
                        <img src={heading} alt="Matrimony" className="h-12 w-32" />
                    </div>
                    <h2 className="text-center text-xl font-semibold my-2">Set New Password!</h2>
                    <h3 className="text-center text-md text-gray-500 mt-2">
                        Your new password must be different from the previous one.
                    </h3>

                    <form className="flex flex-col">
                        {/* Password Section */}
                        <label className="block font-medium mt-2 mb-1">Password</label>
                        <div className="relative">
                            <input
                                type={password.show ? "text" : "password"}
                                className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#E72848]"
                                placeholder="Enter your password"
                                value={password.value}
                                onChange={(e) =>
                                    setPassword({ ...password, value: e.target.value })
                                }
                            />
                            <span
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                onClick={() =>
                                    setPassword({ ...password, show: !password.show })
                                }
                            >
                                {password.show ? (
                                    <FaRegEyeSlash size={20} />
                                ) : (
                                    <MdOutlineRemoveRedEye size={22} />
                                )}
                            </span>
                        </div>
                        <h3 className="text-sm text-gray-500 mt-1 mb-2">
                            Must be at least 8 characters.
                        </h3>

                        {/* Confirm Password Section */}
                        <label className="block font-medium mt-2 mb-1">Confirm Password</label>
                        <div className="relative">
                            <input
                                type={confirmPassword.show ? "text" : "password"}
                                className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#E72848]"
                                placeholder="Confirm your password"
                                value={confirmPassword.value}
                                onChange={(e) =>
                                    setConfirmPassword({ ...confirmPassword, value: e.target.value })
                                }
                            />
                            <span
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                onClick={() =>
                                    setConfirmPassword({
                                        ...confirmPassword,
                                        show: !confirmPassword.show,
                                    })
                                }
                            >
                                {confirmPassword.show ? (
                                    <FaRegEyeSlash size={20} />
                                ) : (
                                    <MdOutlineRemoveRedEye size={22} />
                                )}
                            </span>
                        </div>

                        {/* Reset Button */}
                        <button
                            type="button"
                            onClick={handleResetPassword}
                            className="w-full bg-[#E72848] flex justify-center text-white p-3 my-4 rounded-xl font-semibold hover:bg-[#f53b58] transition duration-300 cursor-pointer"
                            disabled={loading}
                        >
                            {
                                loading ? <CircularProgress size={24} color="inherit" /> : "Reset Password"
                            }

                        </button>

                        <div className="text-center flex justify-center mt-6 gap-2 text-gray-600">
                            <FaArrowLeftLong size={22} />
                            <NavLink
                                to="/signin"
                                className="text-md text-[#535861] font-medium"
                            >
                                Back to Log in
                            </NavLink>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Setnewpass;
